import { isFireFox, isSafari } from 'utils/checkDevice';
import { UseScrollToType } from './types';

const useScrollTo = () => {
  const scrollToPosition = ({ x = 0, y = 0, behavior = 'auto' }: UseScrollToType = {}) => {
    // time out for Safari and FireFox
    if (isSafari || isFireFox) {
      setTimeout(() => {
        window.scrollTo({ top: y, left: x, behavior });
      }, 0);
    } else {
      // For other browsers, just scroll normally
      window.scrollTo({ top: y, left: x, behavior });
    }
  };

  return scrollToPosition;
};

export default useScrollTo;
